import { FileDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { exportAPI } from "@/lib/api";

export default function ExportPage() {
  return (
    <div className="page-container" data-testid="export-page">
      <div className="mb-8">
        <h1 className="text-2xl font-bold tracking-tight text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>
          Exports
        </h1>
        <p className="text-sm text-slate-500 mt-1">Exportez vos listes au format CSV</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* CSV Clients */}
        <Card className="p-5 flex flex-col" data-testid="export-clients-card">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 rounded-lg bg-indigo-100 flex items-center justify-center">
              <FileDown size={20} className="text-indigo-600" />
            </div>
            <div>
              <h3 className="text-sm font-semibold text-slate-800">Clients CSV</h3>
              <p className="text-[11px] text-slate-400">Export de l'annuaire clients et prospects</p>
            </div>
          </div>
          <p className="text-xs text-slate-500 mb-4 flex-1">
            Liste complété des clients et prospects avec coordonnees, SIRET, TVA intra.
          </p>
          <Button variant="outline" onClick={() => { window.open(exportAPI.clientsUrl({}), "_blank"); toast.success("Export CSV clients lance"); }} className="w-full gap-2" data-testid="export-all-clients-btn">
            <FileDown size={15} /> Telecharger CSV
          </Button>
        </Card>

        {/* CSV Documents */}
        <Card className="p-5 flex flex-col" data-testid="export-documents-card">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 rounded-lg bg-emerald-100 flex items-center justify-center">
              <FileDown size={20} className="text-emerald-600" />
            </div>
            <div>
              <h3 className="text-sm font-semibold text-slate-800">Documents CSV</h3>
              <p className="text-[11px] text-slate-400">Export des factures, devis, commandes, avoirs</p>
            </div>
          </div>
          <p className="text-xs text-slate-500 mb-4 flex-1">
            Liste des documents avec montants HT, TVA, TTC, paiements et solde restant du.
          </p>
          <Button variant="outline" onClick={() => { window.open(exportAPI.documentsUrl({}), "_blank"); toast.success("Export CSV documents lance"); }} className="w-full gap-2" data-testid="export-all-documents-btn">
            <FileDown size={15} /> Telecharger CSV
          </Button>
        </Card>
      </div>

      <p className="text-xs text-slate-400 mt-6">
        Utilisez aussi les boutons "Exporter" directement sur les pages Clients et Documents pour exporter avec vos filtres actifs.
      </p>
    </div>
  );
}
